/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";
//import axios from "axios";//有问题的，无法提交。

// 保存
export function publicInvestorSaveOrEdit(data, formName, method = "post") {
    var url =
        formName === "add"
            ? "/public/risk/investor/save"
            : "/public/risk/investor/edit";
    return axios({
        url: url,
        method: method,
        data: data,
    });
}

// 保存
export function publicInvestorQASaveOrEdit(data, formName, method = "post") {
    var url =
        formName === "add"
            ? "/admin/risk/investorQA/save"
            : "/admin/risk/investorQA/edit";
    return axios({
        url: url,
        method: method,
        data: data,
    });
}

// 列表
export function answerList(query) {
    //Message.info("api.questionId: " + query.questionId);
    return axios({
        url: "/admin/risk/answer/index",
        method: "get",
        params: query,
    });
}

// 列表
export function questionList(query) {
    //Message.info("api.questionList");
    return axios({
        url: "/admin/risk/question/index",
        method: "get",
        params: query,
    });
}

export function investorQASaveOrEdit(query) {
    //Message.info("api.questionList");
    return axios({
        url: "/admin/risk/investor/investorQASaveOrEdit",
        method: "get",
        params: query,
    });
}
